<template>
  <span v-if="isMissable && isMissed" class="color-brand">{{
    $t("components.formSubmission.FieldValue.missed")
  }}</span>
  <img
    v-else-if="fieldValue && fieldValue.image"
    :src="fieldValue.image.sizes && fieldValue.image.sizes.sm"
    :alt="fieldValue.image.sizes && fieldValue.image.sizes.sm"
    class="mw-100"
  />
  <!-- for pre-wrap value and div have to be on same line -->
  <!-- prettier-ignore -->
  <span v-else-if="fieldValue" class="text-grey-70 space-pre">{{ fieldValue.value || '-' }}{{ fieldValue.value_type ? ' ' + fieldValue.value_type : '' }}</span>
  <span v-else class="text-grey-70">-</span>
</template>

<script>
import { MISSED_VALUE } from "@/lib/form-utils"

export default {
  props: {
    field: { type: Object, required: true },
    values: { type: Object, required: true },
    isMissable: { type: Boolean, default: false }
  },

  computed: {
    fieldValue() {
      return this.values[this.field.id]
    },

    isMissed() {
      return this.fieldValue?.value === MISSED_VALUE
    }
  }
}
</script>

<style lang="scss" scoped>
.space-pre {
  white-space: pre-wrap;
  font-weight: 600;
  font-size: 14px;
}
</style>
